module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Work in progress")]), _vm._v(" "), _c('app-grid-list', _vm._l((_vm.playlists), function(playlist) {
    return _c('v-flex', {
      key: playlist.id,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg2": ""
      }
    }, [_c('playlist-teaser', {
      attrs: {
        "playlist": playlist
      }
    })], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61ea96fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageUserPlaylists.vue
// module id = 374
// module chunks = 0